import React from 'react';
import { Box } from '@chakra-ui/react';

export default function SectionCard({ children, ...props }) {
  return (
    <Box
      bg="white"
      borderRadius="16px"
      boxShadow="0 1px 2px rgba(0, 0, 0, 0.04)"
      borderWidth="1px"
      borderColor="gray.200"
      p={{ base: 4, md: 6 }}
      {...props}
    >
      {children}
    </Box>
  );
}
